import chassisImg from '../assets/chassis-v2.png';
import trailerJapanLogo from '../assets/trailerjapanlogo.png';

function Chassis() {
  return (
    <section className="section chassis-section" id="chassis">
      <div className="container">
        <div className="section-head reveal">
          <p className="section-label">TRAILER CHASSIS</p>
          <h2 className="section-title">シャーシ販売</h2>
          <p className="section-desc">
            コンテナを載せて移動できる、国産専用シャーシの販売も行っています。
          </p>
        </div>

        <div className="chassis-intro reveal">
          <div className="chassis-intro-heading">
            <img
              src={trailerJapanLogo}
              alt="TRAILER JAPAN"
              className="chassis-intro-logo"
            />

            <h3>
              載せて運ぶを<br />
              もっと快適にする
            </h3>
          </div>

          <div className="chassis-intro-content">
            <p>
              トレーラージャパンは、トレーラーハウス販売業者様向けに、
              日本製シャーシとパーツを低価格・高品質でご提供いたします。
              カラーやカスタマイズにも対応可能です。
            </p>

            <p>
              コンテナをそのまま牽引できる専用シャーシのため、
              設置場所の変更や移動が必要な場合にも対応できます。
              コンテナとのセット購入も可能です。
            </p>
          </div>
        </div>

        <div className="chassis-grid reveal" style={{ '--reveal-delay': '0.12s' }}>
          <div className="chassis-image">
            <img src={chassisImg} alt="シャーシ" />
          </div>

          <div className="chassis-info">
            <ul className="chassis-spec">
              <li><span>対応サイズ</span><span>12FT / 20FT / 24FT / 30FT</span></li>
              <li>
                <span>価格</span>
                <span>
                  シャーシ単体　110万円〜<br />
                  コンテナ＋シャーシ　150万円〜
                </span>
              </li>
              <li><span>納期</span><span>約1ヶ月（在庫状況による）</span></li>
              <li><span>配送</span><span>全国対応</span></li>
            </ul>

            <a href="/chassis" className="chassis-btn">
              シャーシ詳細を見る
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Chassis;
